import { CheckCircleOutlined } from "@mui/icons-material";
import { CircularProgress, Dialog, DialogContent, Stack, Typography } from "@mui/material";
import React from "react";

const SubmitModal = (props) => {
	
	const handleClose = () => {
		props.onClose()
	};
	
	return (
		<Dialog
			open={props.open? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="sm"
		>
			<DialogContent>
				{props.sentSuccess?
					<Stack
						direction="column"
						alignItems="center"
						justifyContent="center"
						spacing={2}
						sx={{ width: "100%", marginBottom: "1em" }}
					>
						<Typography sx={{ margin: "0.5em" }}>Complete</Typography>
						<CheckCircleOutlined sx={{ width: "2.5em", height: "2.5em" }} />
					</Stack>
				:
					<Stack
						direction="column"
						alignItems="center"
						justifyContent="center"
						spacing={2}
						sx={{ width: "100%", marginBottom: "1em" }}
					>
						<Typography sx={{ margin: "0.5em" }}>Please Wait</Typography>
						<CircularProgress size="3em" />
					</Stack>
				}
			</DialogContent>
			
		</Dialog>
	);

}

export default SubmitModal;